module.exports = __webpack_public_path__ + "static/img/gabba.96f4a1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gabba.png
// module id = PIWG
// module chunks = 2